import { parseMarkdownWithRemark } from './markdownRemarkRuntime';

export const parseMarkdown = (markdown) => {
  if (process.env.NODE_ENV === 'test') {
    // eslint-disable-next-line global-require
    return require('./markdownLegacy').parseMarkdown(markdown);
  }

  return parseMarkdownWithRemark(markdown);
};
